import { styled } from '@linaria/react';

import Layer from './Layer';

type LayerData = {
  src: string;
  name: string;
};

interface Props {
  layerWidth: number;
  layers: Array<LayerData>;
}

const SkewedLayers = ({ layerWidth = 250, layers }: Props) => {
  return (
    <OuterWrapper>
      <Wrapper>
        {layers.map((layer, index) => {
          return (
            <Layer
              key={layer.name}
              index={index}
              name={layer.name}
              src={layer.src}
              width={layerWidth}
              numOfLayers={layers.length}
            />
          );
        })}
      </Wrapper>
    </OuterWrapper>
  );
};

const OuterWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 128px 0 64px;
`;

const Wrapper = styled.div`
  position: relative;
  isolation: isolate;
`;

export default SkewedLayers;
